import { api } from '../services/api';

/**
 * Переводит текст с русского на английский через бэкенд API
 * @param text - Текст для перевода
 * @returns Переведенный текст
 */
export const translateToEnglish = async (text: string): Promise<string> => {
  try {
    if (!text || text.trim().length === 0) {
      return '';
    }

    const response = await api.post('/translate', {
      text,
      from: 'ru',
      to: 'en'
    });

    if (response.data.success) {
      return response.data.text;
    } else {
      throw new Error(response.data.error || 'Translation failed');
    }
  } catch (error: any) {
    console.error('Translation error:', error);
    const errorMessage = error.response?.data?.error || error.message || 'Failed to translate text. Please try again.';
    throw new Error(errorMessage);
  }
};

